module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/80ad76114d0b3f2fc54a3756dd283a53.svg";